export default "__VITE_ASSET__3dzGCrxD__"